import { createAction } from "redux-starter-kit";
import { APP_ISSUES_PROD_SET } from "../actionTypes";
import { getIssueProdApi } from "../../api/issues";

export const appSetIssueProdAction = createAction(APP_ISSUES_PROD_SET);

export function loadAnIssueProdRequestAction(issueID) {
  return async dispatch => {
    try {
      let aProdIssue = await getIssueProdApi(issueID);
      dispatch(appSetIssueProdAction({ issueProd: aProdIssue }));
    } catch (e) {
      console.log(e.toString());
    }
  };
}
